import { createSelector } from '@ngrx/store';
import { Enrollment } from '@rd/types';
import { getEnrollmentFeatureState } from '../reducers';
import { EnrollmentState } from '../reducers/enrollment.reducer';

const getError = (state: EnrollmentState) => state.error;
const getLoading = (state: EnrollmentState) => state.loading;
const getSuccess = (state: EnrollmentState) => state.success;
const getAllEnrollmentsMap = (state: EnrollmentState) => state.enrollments;
const getAllEnrollments = (state: EnrollmentState) =>
  Object.values(state.enrollments);
const getEnrollmentsWithGroupedEnrollments = (state: EnrollmentState) => {
  const enrollments = Object.values(state.enrollments);
  return enrollments.filter(
    (enrollment: Enrollment) =>
      enrollment.groupedEnrollments !== undefined &&
      enrollment.groupedEnrollments.length > 0,
  );
};

export const getEnrollmentsMap = createSelector(
  getEnrollmentFeatureState,
  getAllEnrollmentsMap,
);

export const getEnrollments = createSelector(
  getEnrollmentFeatureState,
  getAllEnrollments,
);

export const getEnrollmentsSuccess = createSelector(
  getEnrollmentFeatureState,
  getSuccess,
);

export const getGroupedEnrollments = createSelector(
  getEnrollmentFeatureState,
  getEnrollmentsWithGroupedEnrollments,
);

export const getEnrollmentError = createSelector(
  getEnrollmentFeatureState,
  getError,
);

export const getEnrollmentLoading = createSelector(
  getEnrollmentFeatureState,
  getLoading,
);
